import firebase from 'firebase'

var config = {
    apiKey: process.env.VUE_APP_fb_apiKey,
    authDomain: process.env.VUE_APP_fb_authDomain,
    databaseURL: process.env.VUE_APP_fb_databaseURL,
    projectId: process.env.VUE_APP_fb_projectId,
    storageBucket: process.env.VUE_APP_fb_storageBucket,
    messagingSenderId: process.env.VUE_APP_fb_messagingSenderId
};

const firebaseApp = firebase.initializeApp(config);
// firebaseApp.firestore().settings({ timestampsInSnapshots: true })

export default firebaseApp